import { Controller } from "@hotwired/stimulus"
import { Chart, ArcElement, Tooltip, Legend, PieController } from "chart.js"
import { CHART_COLORS, getColorByIndex } from "../config/chart_colors"

// Register Chart.js components
Chart.register(ArcElement, Tooltip, Legend, PieController)

// Connects to data-controller="chart"
export default class extends Controller {
  static values = {
    labels: Array,
    data: Array,
    type: { type: String, default: "pie" }
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const ctx = this.element.getContext("2d")

    // Generate colors for each segment
    const colors = this.generateColors(this.dataValue.length)

    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: {
        labels: this.labelsValue,
        datasets: [{
          data: this.dataValue,
          backgroundColor: colors.background,
          borderColor: colors.border,
          borderWidth: 2
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: 'right',
            labels: {
              padding: 15,
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || ''
                const value = context.parsed || 0
                const total = context.dataset.data.reduce((a, b) => a + b, 0)
                const percentage = ((value / total) * 100).toFixed(1)
                return `${label}: ${value} (${percentage}%)`
              }
            }
          }
        }
      }
    })
  }

  generateColors(count) {
    const background = []
    const border = []

    for (let i = 0; i < count; i++) {
      const color = getColorByIndex(i)
      background.push(color.bg)
      border.push(color.border)
    }

    return { background, border }
  }
}
